/** The totals message for pagination. Displays like "Showing 1 - 10 of 50". */
export const showTotal = (total: number, range: [number, number]) => {
  return `Showing ${range[0]} to ${range[1]} of ${total}`;
};
